import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { NgIf } from "@angular/common";

import { DEFAULT_ACCENT } from "../../models/event.models";

/**
 * Editorial hero used at the top of every events view. Takes an optional
 * background image; without one it falls back to a tinted gradient built
 * from the accent colour, so a series with no artwork still looks designed.
 */
@Component({
    selector: "app-events-hero",
    standalone: true,
    imports: [NgIf],
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: "./events-hero.component.html",
    styleUrl: "./events-hero.component.scss",
})
export class EventsHeroComponent {
    @Input() eyebrow?: string | null;
    @Input({ required: true }) title!: string;
    @Input() subtitle?: string | null;
    @Input() imageUrl?: string | null;
    @Input() accent: string = DEFAULT_ACCENT;
    @Input() compact = false;
}
